import { FC, MouseEventHandler } from 'react';

import { FormControlLabel, FormGroup, Radio, RadioGroup } from '@mui/material';

import { SignerFlow } from 'constants/signNow';
import { IReadonlySignerFlowConfig, ISignerFlowConfigItem } from 'types/signNow/selectSigners';

interface ISignerFlowProps {
  currentSignerFlow: SignerFlow,
  config: IReadonlySignerFlowConfig,
  onChange: MouseEventHandler<HTMLButtonElement>,
  addBulkSendFlow?: boolean;
  disableJustMeFlow?: boolean;
}

const SignerFlowComponent: FC<ISignerFlowProps> = ({
  currentSignerFlow,
  config,
  onChange,
  addBulkSendFlow = false,
  disableJustMeFlow = false,
}) => (
  <FormGroup>
    <RadioGroup
      aria-labelledby="radio-buttons-signer-flow"
      name="signer-flow"
      value={currentSignerFlow}
    >
      {
        Object.values(config).map(({ key, label, isHidden }: ISignerFlowConfigItem) => (
          <FormControlLabel
            key={key}
            hidden={isHidden || (disableJustMeFlow && key === SignerFlow.JustMe)}
            value={key}
            label={label}
            control={<Radio onClick={onChange} />}
          />
        ))
      }
      {
        addBulkSendFlow && (
          <FormControlLabel
            key={SignerFlow.BulkSend}
            value={SignerFlow.BulkSend}
            label="Bulk Send"
            control={<Radio onClick={onChange} />}
          />
        )
      }
    </RadioGroup>
  </FormGroup>
);

export default SignerFlowComponent;